import styled from 'styled-components';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import React, { useState } from 'react';
import Btn from './Btn';

interface TableOptionWrapProps {
  postNum: string;
  children: React.ReactNode;
}

const TableOptionWrap = ({ postNum, children }: TableOptionWrapProps) => {
  return (
    <>
      <Wrap>
        <h3>
          전체 <span>{postNum}</span>개
        </h3>
        <OptionWrap>{children}</OptionWrap>
      </Wrap>
    </>
  );
};

export default TableOptionWrap;

const Wrap = styled.div`
  margin-top: 28px;
  display: flex;
  justify-content: space-between;
  align-items: flex-end;
  > h3 {
    font-size: 14px;
    color: #111;
    > span {
      display: inline-block;
      font-weight: 700;
      color: ${({ theme }) => theme.mainColor1};
    }
  }
`;

const OptionWrap = styled.div`
  display: flex;
  gap: 6px;
`;
